module.exports = {
      id: "Play_Circle-usage",
      viewBox: "0 0 34.388 34.388",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Play_Circle-usage",
      toString: function () {
        return this.url;
      }
    }